/*
 * @Author: your name
 * @Date: 2020-09-01 17:44:49
 * @LastEditTime: 2020-09-11 18:12:28
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \eunke-st-www\src\server\common.js
 */
import http from "../utils/http";

export default {
    /**
     * 通用导出
     * @param {导出url} url 
     * @param {传参} data 
     * @param {回调函数} fun 
     */
    exportTable: function(url,data,fun) {
        console.log(url,data)
        http.getExport(url,data,fun)
    },
}

/**
 * 通用导出
 * @param {导出url} url 
 * @param {传参} data 
 * @param {回调函数} fun 
 */
export const exportTable = function(url,data,fun) {
    console.log(url,data)
    http.getExport(url,data,fun)
}